export default __webpack_public_path__ + "static/media/message-node.3293fc5d.svg";